const requireroute = require.context(".", false, /\.js$/);
let routes = [];

requireroute.keys().forEach((fileName) => {
  if (fileName === "./index.js") return;

  routes = routes.concat(requireroute(fileName).default);
});

export default routes;
